import { useMessage } from "hooks/intl";
import { formatNumberValue } from "utilities/numbers";

export function UnlimitedValueWrapper({ value }: { value: any }) {
  const { message } = useMessage();
  const unlimited = -1;

  return (
    <>
      {value === unlimited
        ? message({ id: "unlimited" })
        : formatNumberValue(value)}
    </>
  );
}
